import React, { useCallback } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import Billet from '~/src/features/center/Billet';
import HeaderTitle from '~/src/features/center/HeaderTitle';
import { useScroll } from '~/src/helpers/hooks/useScroll';

import * as ST from './styled';

interface IHeaderProps {
    withForm: boolean,
    companyName: string,
    footerRef: React.RefObject<HTMLElement>,
}

const Header: React.FC<IHeaderProps> = ({ withForm, companyName, footerRef }: IHeaderProps) => {

    const scrollToRef = useScroll();
    const onClickHandler = useCallback(() => {
        scrollToRef(footerRef);
        dataLayerPush({ event: EVENTS.UAevent, category: CATEGORIES.paidServices, action: ACTIONS.clickConsultation, label: 'null' });
    }, [footerRef, scrollToRef]);

    return (
        <ST.Wrapper>
            <ST.GridContainerColumn>
                <Billet/>
                <HeaderTitle
                    withForm={withForm}
                    companyName={companyName}
                    clickHandler={onClickHandler}
                />
            </ST.GridContainerColumn>
        </ST.Wrapper>
    );
};

export default Header;
